import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import WaveSurfer from 'wavesurfer.js/dist/wavesurfer.min'
import WaveSurferMicrophone from 'wavesurfer.js/dist/plugin/wavesurfer.microphone'
import WaveSurferRegions from 'wavesurfer.js/dist/plugin/wavesurfer.regions'
import Timer from 'easytimer'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import { normalizeRecordFiles } from 'helpers/pickerNormalizer'
import Isvg from 'react-inlinesvg'
import { localize } from 'helpers/translator'

import timeFormat from 'helpers/dateFormat/timeFormat'
import styles from './nearpod_picker_audio_recorder.scss'
import classNames from 'classnames/bind'
const cx = classNames.bind(styles)


const StartRecordingSvg = () => <svg height="80" width="80" viewBox="0 0 80 80"> <ellipse cx="40" cy="40" fill="#F26C59" rx="40" ry="40"/> <path d="M40.32 46.27c4.15 0 7.32-3.17 7.32-7.32V24.32c0-4.15-3.17-7.32-7.32-7.32S33 20.17 33 24.32v14.63c0 4.15 3.17 7.32 7.32 7.32zm-.25 5.17c-6.83 0-12.93-5.12-12.93-12.44H23c0 8.29 6.58 15.12 14.63 16.34v8.05h4.88v-8.05c8.05-1.22 14.63-8.05 14.63-16.34H53c0 7.32-6.1 12.44-12.93 12.44z" fill="#FFF"/> </svg>
const PauseRecordingSvg = () => <svg height="80" width="80" viewBox="0 0 80 80"> <ellipse cx="40" cy="40" fill="#F26C59" rx="40" ry="40"/> <path d="M44.01 25.34c0-1.92 1.56-3.48 3.49-3.48 1.92 0 3.49 1.56 3.49 3.48v29.32c0 1.92-1.56 3.48-3.49 3.48-1.92 0-3.49-1.56-3.49-3.48V25.34zm-15 0c0-1.92 1.56-3.48 3.49-3.48 1.92 0 3.49 1.56 3.49 3.48v29.32c0 1.92-1.56 3.48-3.49 3.48-1.92 0-3.49-1.56-3.49-3.48V25.34z" fill="#FFF"/> </svg>
const PlayAudioSvg = () => <svg height="44" width="44" viewBox="0 0 44 44" > <path className="nearpod_picker_audio_recorder__color-change" fill="#00a8ff" d="M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22z"/> <path d="M16.194 12.07L32.137 22l-15.943 9.93" fill="#fff"/> </svg>
const PauseAudioSvg = () => <svg height="44" width="44" viewBox="0 0 44 44"> <path fill="#00a8ff" d="M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22z"/> <path d="M24.214 13.918c0-1.06.853-1.918 1.92-1.918 1.063 0 1.923.86 1.923 1.918v16.164c0 1.06-.853 1.918-1.922 1.918-1.06 0-1.92-.86-1.92-1.918V13.918zm-8.27 0c0-1.06.852-1.918 1.92-1.918 1.062 0 1.922.86 1.922 1.918v16.164c0 1.06-.853 1.918-1.92 1.918-1.063 0-1.923-.86-1.923-1.918V13.918z" fill="#fff"/> </svg>
//const AudioPlaceholderSvg = () => <svg height="34" width="314" viewBox="0 0 314 34"> <path d="M308 3a3 3 0 0 1 6 0v28a3 3 0 0 1-6 0zM0 3a3 3 0 0 1 6 0v28a3 3 0 0 1-6 0zM32 12a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48-7a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zM8 10a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0zm48-1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 5a1 1 0 0 1 2 0v7a1 1 0 0 1-2 0zM40 11a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm48 2a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48-8a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zM16 12a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48-7a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm48 10a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0zm-64-4a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm48-6a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm48 5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0zM24 15a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0zm48-3a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48-2a1 1 0 0 1 2 0v15a1 1 0 0 1-2 0zm-84 3a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48-7a1 1 0 0 1 2 0v23a1 1 0 0 1-2 0zM12 9a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 3a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0zm48-3a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zM44 9a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 2a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm48-2a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zM20 13a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48-4a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 2a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zM52 9a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48-1a1 1 0 0 1 2 0v18a1 1 0 0 1-2 0zm48 4a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0zM28 13a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm96-4a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zM76 9a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm84-4a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm48 7a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm-72-2a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0zm48-1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zM168 5a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm48 6a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm48 2a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm28 0a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm-100-1a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm48-7a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm48 10a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0zm-112-5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0zm48 1a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm48-6a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zm28 0a1 1 0 0 1 2 0v24a1 1 0 0 1-2 0zM200 15a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0zm48-3a1 1 0 0 1 2 0v11a1 1 0 0 1-2 0zm-84-3a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 4a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm-72-4a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 3a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0zM172 9a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 0a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48 2a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm28 0a1 1 0 0 1 2 0v13a1 1 0 0 1-2 0zm-100 2a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48-4a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm-64 2a1 1 0 0 1 2 0v12a1 1 0 0 1-2 0zm48-2a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0zm48-1a1 1 0 0 1 2 0v18a1 1 0 0 1-2 0zm28 0a1 1 0 0 1 2 0v18a1 1 0 0 1-2 0zm-100 5a1 1 0 0 1 2 0v9a1 1 0 0 1-2 0zm48-4a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0z" fill="#b8c0c6"/> </svg>
//const DeleteAudioSvg = () => <svg height="24" width="20" viewBox="-42 79 17 20"> <path fill="#3f535d" d="M-31.5 87.3c-.3 0-.6.2-.6.6v4.5c.1.3.3.5.6.5s.6-.3.6-.6v-4.4c0-.3-.2-.6-.6-.6z"/> <path fill="#3f535d" d="M-26.7 82.3h-2.9v-.8c0-.8-.7-1.5-1.5-1.5h-4.4c-.8 0-1.5.7-1.5 1.5v.8h-3.2c-.4 0-.8.3-.8.8s.3.8.8.8h.6l.4 11.6c0 1.4 1.1 2.5 2.5 2.5h6.4c1.4 0 2.5-1.1 2.5-2.5l.4-11.6h.6c.4 0 .8-.3.8-.8s-.3-.8-.7-.8zm-8.8 0v-.7l4.3-.1v.8h-4.3zm6.2 13.1c0 .6-.5 1-1 1h-6.4c-.6 0-1-.5-1-1l-.4-11.6h9.3l-.5 11.6z"/> <path fill="#3f535d" d="M-35.5 87.3c-.3 0-.6.3-.6.6v4.5c.1.3.3.5.6.5s.6-.3.6-.6v-4.4c0-.3-.3-.6-.6-.6zM-33.5 86.3c-.3 0-.6.3-.6.6v6.5c.1.3.3.5.6.5s.6-.3.6-.6v-6.4c0-.3-.3-.6-.6-.6z"/> </svg>

import AudioPlaceholderSvg from 'assets/components/nearpod_picker/audio_recorder/placeholder-waveform.svg'
import DeleteAudioSvg from 'assets/components/nearpod_picker/audio_recorder/audio-player-delete-btn.svg'

class NearpodPickerAudioRecorder extends PureComponent {

	constructor() {
		super()
		this.startRecording = this.startRecording.bind(this)
		this.pauseRecording = this.pauseRecording.bind(this)
		this.playAudio = this.playAudio.bind(this)
		this.pauseAudio = this.pauseAudio.bind(this)
		this.deleteAudio = this.deleteAudio.bind(this)
		this.save = this.save.bind(this)

		this.defaultState = {
			chunk: [],
			initiated: false,
			recording: false,
			playing: false,
			microphoneReady: false,
			blob: null,
			recordedTime: '0:00',
			waveformColor: '#ff0000',
			updating: false,
			audioRegion: {
				start: 0,
				end: 0,
			},
		}

		this.state = { ...this.defaultState }
	}

	initializeRecorder() {
		//
		this.recorder = new MediaRecorder(this.stream)

		this.recorder.ondataavailable = e => {
			this.setState({
				chunk: [...this.state.chunk, e.data],
			})
			/*this.setState({
				chunk: [...this.state.chunk, e.data]
			})*/
		}
	}

	initializeTimer() {
		this.timer = new Timer()
		this.timer.addEventListener('secondsUpdated', () => {
			const seconds = this.timer.getTimeValues().seconds
			const formattedSeconds = seconds<10?'0'+seconds:seconds

			this.setState({
				recordedTime: this.timer.getTimeValues().minutes + ':' + formattedSeconds,
			})
		})
	}

	componentDidUpdate(prevProps, prevState) {
		//When chunk differs, it means a new recording has been made, so a new waveform will be built
		if (prevState.chunk !== this.state.chunk && this.state.chunk.length) {
			this.makeWaveform()
		}
		//Playing set to true
		if ((prevState.playing === false && this.state.playing === true)) {
			if (!this.wavesurfer.isPlaying()) {
				const waveCurrentTime = this.wavesurfer.getCurrentTime()
				let startRegion
				if (waveCurrentTime >= this.state.audioRegion.start && waveCurrentTime < this.state.audioRegion.end) {
					startRegion = waveCurrentTime

				} else {
					startRegion = this.state.audioRegion.start
				}
				this.wavesurfer.play(startRegion, this.state.audioRegion.end)
			}
		}
		//Playing set to false
		if (prevState.playing === true && this.state.playing === false) {
			if (this.wavesurfer.isPlaying()) {
				this.wavesurfer.pause()
			}
		}
		//Recording ended
		if (prevState.recording === true && this.state.recording === false) {
			this.timer.pause()
			this.recorder.requestData()
			this.recorder.pause()
			this.microphone.pause()
		}
		//Recording started
		if (prevState.recording === false && this.state.recording === true) {
			if (this.state.chunk.length !== 0) {
				this.recorder.resume()
			} else {
				this.recorder.start()
			}
			this.regions.clear()
			this.microphone.start()
			this.timer.start({precision: 'secondTenths'})
		}
		//Audio Region updated
		if (prevState.audioRegion !== this.state.audioRegion && this.state.updating === false) {
			setTimeout(() => this.wavesurfer.seekTo(0), 100)
		}
		//Recording Deleted
		if (prevState.blob !== null && this.state.blob === null) {
			this.regions.clear()
			this.wavesurfer.empty()
		}
		if (prevState.waveformColor !== this.state.waveformColor && this.wavesurfer) {
			this.wavesurfer.params.waveColor = this.state.waveformColor
		}
	}

	destroyStream(stream) {
		if (stream) {
			if (stream.getTracks && stream.getTracks().length) {
				stream.getTracks()[0].stop()
			}
			if (stream.stop) {
				stream.stop()
			}
		}
	}

	startRecording() {
		if (this.recorder) {
			this.pauseAudio()

			this.setState({
				recording: true,
				initiated: true,
				waveformColor: '#3f535d',
			})
		}
	}

	pauseRecording() {
		this.setState({
			recording: false,
			waveformColor: '#b8c0c6',
		})

	}

	playAudio() {
		this.setState({
			playing: true,
		})
	}

	pauseAudio() {
		this.setState({
			playing: false,
		})
	}

	deleteAudio() {
		this.initializeRecorder()
		this.initializeTimer()
		this.setState(this.defaultState)
	}

	makeWaveform() {
		var blob = new Blob(this.state.chunk, {type: 'audio/ogg' })
		var url = URL.createObjectURL(blob)
		this.wavesurfer.once('ready', () => {
			this.regions.add({
				start: 0,
				end: this.wavesurfer.getDuration(),
				drag: true,
			})
			this.setState({
				audioRegion: {...this.state.audioRegion, ...{start: 0, end: this.wavesurfer.getDuration()}},
				playing: false,
			})
		})
		this.wavesurfer.load(url)
		this.setState({
			blob,
		})
	}

	save() {
		this.props.onFilesPicked(normalizeRecordFiles([this.state.blob], this.state.audioRegion.start + ':' + this.state.audioRegion.end))
	}

	componentDidMount() {
		if (navigator.mediaDevices !== undefined && navigator.mediaDevices.getUserMedia !== undefined ) {
			navigator.mediaDevices.getUserMedia({audio: true})
				.then(stream => {
				// Audio recoder API works and permissions granted
					this.stream = stream
					this.initializeWidgets()
				}).catch(() => {
				// Audio recorder API dont work
				})

		}
	}

	initializeWidgets() {
		this.initializeRecorder()
		this.initializeTimer()
		this.initializeWavesurfer()
	}

	initializeWavesurfer() {

		this.wavesurfer = WaveSurfer.create({
			container: '.' + cx('audio-recorder-player-container-controls'),
			waveColor: this.state.waveformColor,
			progressColor: '#3f535d',
			height: 42,
			barHeight: 2,
			barWidth: 3,
			cursorWidth: 0,
			hideScrollbar: true,
			plugins: [
				WaveSurferMicrophone.create({}),
				WaveSurferRegions.create({}),
			],
		})
		this.wavesurfer.on('seek', () => {
			if (this.state.playing) {
				const currentTime = this.wavesurfer.getCurrentTime()
				if (currentTime >= this.state.audioRegion.start && currentTime < this.state.audioRegion.end) {
					//this.wavesurfer.play(currentTime, this.state.audioRegion.end)
				} else {
					this.pauseAudio()
				}
			} else {
				this.wavesurfer.pause()
			}
		})
		//Need to attach to this event because when audio reaches the end of the region and region.end < wavesurfer.end,
		//no event is fired
		this.wavesurfer.on('pause', () => {
			if (this.state.playing) {
				this.pauseAudio()
			}
		})
		this.wavesurfer.on('play', () => {
			if (!this.state.playing) {
				this.playAudio()
			}
		})
		this.wavesurfer.on('audioprocess', time => {
			this.setState({
				recordedTime: timeFormat(time),
			})
		})
		//No need for this event
		/*this.wavesurfer.on('region-out', () => {
			this.pauseAudio()
		})*/
		this.initializeMicrophone()
		this.initializeRegions()
	}

	initializeMicrophone() {
		this.microphone = this.wavesurfer.microphone
		this.microphone.on('deviceReady', stream => {
			this.setState({
				microphoneReady: true,
			})
			this.stream = stream
		})
	}

	initializeRegions() {
		this.regions = this.wavesurfer.regions
		//No need for this event
		this.wavesurfer.on('region-updated', ev => {
			this.setState({
				updating: true,
				playing: false,
				audioRegion: {start: ev.start, end: ev.end},
			})

		})
		this.wavesurfer.on('region-update-end', ev => {
			if (this.state.audioRegion.start !== ev.start || this.state.audioRegion.end !== ev.end) {
				this.setState({
					updating: false,
					audioRegion: {start: ev.start, end: ev.end},
				})
			}
		})
	}

	componentWillUnmount() {
		if (this.wavesurfer) {
			this.wavesurfer.pause()
		}
		this.destroyStream(this.stream)
		if (this.recorder) {
			this.destroyStream(this.recorder.stream)
		}
	}

	render() {

		let leftWidth = 0
		let rightWidth = 0
		if (this.state.blob && this.wavesurfer) {
			leftWidth = ((this.state.audioRegion.start / this.wavesurfer.getDuration()) * 314) + 'px'
			rightWidth = ((1 - (this.state.audioRegion.end / this.wavesurfer.getDuration())) * 314) + 'px'
		}

		const leftTimeValue = timeFormat(this.state.audioRegion.start)
		const rightTimeValue = timeFormat(this.state.audioRegion.end)

		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_audio_recorder_title')}</SecondaryTitle>
				<div styleName='audio-recorder'>
					<div styleName='audio-recorder-controls'>
						{ !this.state.recording &&
							<button styleName='audio-recorder-controls-btn' onClick={this.startRecording}>
								<StartRecordingSvg />
							</button>
						}
						{ this.state.recording &&
							<button styleName='audio-recorder-controls-btn' onClick={this.pauseRecording}>
								<PauseRecordingSvg />
							</button>
						}
					</div>
					<p styleName='audio-recorder-elapsed-time'>{this.state.recordedTime}</p>

					<div styleName={
						classNames({
							'audio-recorder-player': true,
							'audio-recorder-player--disabled': (!this.state.initiated || (this.state.initiated && this.state.recording)),
						})
					}>

						{ !this.state.playing &&
							<button
								disabled={!this.state.chunk.length || this.state.recording}
								styleName='audio-recorder-player-controls'
								onClick={this.playAudio}>
								<PlayAudioSvg />
							</button>
						}
						{ this.state.playing &&
							<button styleName='audio-recorder-player-controls' onClick={this.pauseAudio}>
								<PauseAudioSvg />
							</button>
						}

						<div styleName={
							classNames({
								'audio-recorder-player-placeholder': true,
								'audio-recorder-player-placeholder--hidden': this.state.initiated,
							})
						}>
							<Isvg src={AudioPlaceholderSvg} cacheGetRequests={true} />
						</div>
						<div styleName={
							classNames({
								'audio-recorder-player-container': true,
								'audio-recorder-player-container--hidden': !this.state.initiated,
							})
						}>
							<div styleName="audio-recorder-player-container-controls"></div>
						</div>
						{this.state.blob && !this.state.recording && <div styleName='audio-recorder-player-margin-left' style={{width: leftWidth}}>
							<div styleName='audio-recorder-player-margin-time_display audio-recorder-player-margin-time_display--left'>{leftTimeValue}</div>
						</div>}
						{this.state.blob && !this.state.recording && <div styleName='audio-recorder-player-margin-right' style={{width: rightWidth}}>
							<div styleName='audio-recorder-player-margin-time_display'>{rightTimeValue}</div>
						</div>}
						{/* this.state.blob && !this.state.recording &&
							<div styleName='audio-recorder-player-container'>
								<Wavesurfer
									audioFile={this.state.blob}
									playing={this.state.playing}
									volume={1}
									options={{
										progressColor: '#3f535d',
										height: 44,
										barHeight: 2,
										barWidth: 3,
										cursorWidth: 0,
										hideScrollbar: true
									}} />
							</div>
						*/}
						<button disabled={!this.state.blob || this.state.recording} styleName='audio-recorder-player-delete' onClick={this.deleteAudio}>
							<Isvg src={DeleteAudioSvg} cacheGetRequests={true} styleName='color-change'/>
						</button>
					</div>
				</div>
				<NearpodPickerBottomBar cancelHandler={this.props.closeHandler} saveHandler={this.save} saveButtonEnabled={this.state.blob && !this.state.recording} />
			</div>
		)
	}

}

export default CSSModules(NearpodPickerAudioRecorder, styles, {allowMultiple: true})
